// Generated by frontend/scripts/build-js.mjs. Do not edit.
export const pageLoaders = {
  "about": () => import("../pages/about.js"),
  "admin-post-form": () => import("../pages/admin-post-form.js"),
  "admin-settings": () => import("../pages/admin-settings.js"),
  "contact": () => import("../pages/contact.js"),
  "home": () => import("../pages/home.js"),
};
